import { jsx as _jsx } from "react/jsx-runtime";
import { Center, Loader } from 'xen-ui';
export const AppLoader = () => {
    return (_jsx(Center, { "data-testid": "loader", h: "100vh", w: "100%", children: _jsx(Loader, { size: "xl" }) }));
};
